import { MINUTES } from '@/utils/constants';

export const ROOM_FALLBACK_IMAGE_LABEL: string = 'hQo6Uyo4nBg';

export const SHOW_DIFFERENT_ROOM_LEAVE_MESSAGE_AFTER: number = 2 * MINUTES;
